export const ns = "addLearnerManual"

export type ConnectionType = "email" | "code" | ""
